import {
  MediaSignedUrlResponseSchema,
  type MediaSignedUrlRequest,
  type MediaSignedUrlResponse,
} from '../contracts/media';
import type { RequestFn } from './client';

/**
 * Namespace `client.media` — short-lived signed URL для R2-ключей.
 * Контракт: `docs/architecture/api-contracts.md` §3.5.
 */
export interface MediaApi {
  signedUrls(req: MediaSignedUrlRequest): Promise<MediaSignedUrlResponse>;
}

export function createMediaApi(request: RequestFn): MediaApi {
  return {
    signedUrls: (req) =>
      request({
        method: 'POST',
        path: '/api/media/signed-url',
        body: req,
        responseSchema: MediaSignedUrlResponseSchema,
      }),
  };
}
